import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {withSnackbar} from "notistack";
import {isMobile, isMobileOnly, isTablet} from "react-device-detect";
import {startLoadingAnimate, stopLoadingAnimate,} from "services/ducks/loading";
import {Col, Row} from "react-bootstrap";
import * as FontAwesome from "@fortawesome/react-fontawesome";
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import {faSave} from "@fortawesome/free-regular-svg-icons";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons"
import {ContainerTitle, FullSizedButton} from "../styles";
import api from "services/structure/api";

class MeuPlanoContracheque extends Component {

  state = {
    parametros: {}
  }

  downloadListaContracheques() {
    return api.get("/beneficio/lista-contracheques")
      .then(response => {
        const listaContracheques = response.data;
        this.setState({ listaContracheques: listaContracheques });
      })
      .catch((e) => {
        const mensagem = "Não foi possível conectar-se ao servidor3. Recarregue a página! ";
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
        console.log(e);
      });
  }

  downloadContracheque = async (text, abono) => {
    const mesAnoInforme = text.replace(/\//g, "-");
    this.props.startLoadingAnimate();

    return await api.get("beneficio/contracheque/" + mesAnoInforme + "?abono="+abono, {
        responseType: "blob",
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Contracheque_" + mesAnoInforme + ".pdf" );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        this.props.stopLoadingAnimate()
      })
      .catch((err) => {
        console.error(err)
        const mensagem = "Não foi possível realizar o download do contracheque. " + err;
        this.props.enqueueSnackbar(mensagem, { variant: 'error' });
        this.props.stopLoadingAnimate()
      });
  };


  componentDidMount() {
    this.props.startLoadingAnimate();
    const promises = [];
    promises.push(this.downloadListaContracheques());


    Promise.all(promises)
      .finally(() => this.props.stopLoadingAnimate());

    window.scrollTo(0, 0);
  }

  navigateTo(route) {
    this.props.history.push(route);
  }

  dateConstructorFromTimestamp = timestamp => {
    if (!timestamp) {
      return null;
    }
    return new Date(timestamp);
  }

  setStateOnValueChange = (key, value) => {
    const parametros = this.state.parametros;
    parametros[key] = value;
    this.setState({ parametros: parametros });
  }

  renderGridContrachequeDesktop = () => {
    return <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Mês Pagamento</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {this.renderGridHistoricoRowIterator(this.renderGridHistoricoSingleRowDesktop)}
        </TableBody>
      </Table>
    </TableContainer>
  }

  renderGridHistoricoRowIterator = (handleRow) => {
    if (!this.state.listaContracheques) {
      return;
    }
    return this.state.listaContracheques.data.map(handleRow)
  }

  renderGridHistoricoSingleRowDesktop = (element) => {
    return <TableRow key={element.mesPagamento}>
      <TableCell>{element.mesPagamento + (element.abono? " (abono)" : "")}</TableCell>
      <TableCell>
          <FullSizedButton
              type="submit"
              className="alterar-contribuicao-salvar-button"
              variant="contained"
              onClick={() => this.downloadContracheque(element.mesPagamento, element.abono)}>
              <FontAwesome.FontAwesomeIcon icon={faSave} className="alterar-contribuicao-salvar-icon" />
              <span className="alterar-contribuicao-salvar-label">Download</span>
            </FullSizedButton>
      </TableCell>
    </TableRow>
  }


  render() {
    return (
      <div className="meu-plano-alterar-contribuicao">
        {isTablet && <ContainerTitle>MEU PLANO | <span className="meu-plano-alterar-contribuicao-subtitle-container">CONTRACHEQUES</span></ContainerTitle>}
        <Row className="meu-plano-alterar-contribuicao-title-container">
          <Col sm={isTablet ? 6 : 8}>
            {!isMobile && <ContainerTitle>MEU PLANO | <span className="meu-plano-alterar-contribuicao-subtitle-container">CONTRACHEQUES</span></ContainerTitle>}
            {isMobileOnly && <ContainerTitle>MEU PLANO <br /> <span className="meu-plano-alterar-contribuicao-subtitle-container">CONTRACHEQUES</span></ContainerTitle>}
          </Col>
        </Row>
        
        <div className="historico-alteracao-contribuicoes">
          <div className="">
            <h4>Histórico de Contracheques</h4>
          </div>
          {!isMobile && this.renderGridContrachequeDesktop()}
        </div>
        <Row>
          {!isTablet && <Col sm={6}></Col>}
          <Col sm={isTablet ? 6 : 3}>
            <FullSizedButton
              type="submit"
              className="alterar-contribuicao-voltar-button"
              variant="contained"
              onClick={() => this.navigateTo('/app/meu-plano')}>
              <FontAwesome.FontAwesomeIcon icon={faArrowLeft} className="alterar-contribuicao-voltar-icon" />
              <span className="alterar-contribuicao-voltar-label">VOLTAR AO MENU ANTERIOR</span>
            </FullSizedButton>
          </Col>
        </Row>        
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  authData: store.authState,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    startLoadingAnimate,
    stopLoadingAnimate
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withSnackbar(MeuPlanoContracheque)));
